import axios from 'axios';
import store from '../store';
import { getUserSuccess } from '../actions/user-actions';
export function getMyProfile() {
  return axios.get('/code/apis.php?api=getMyProfile')
    .then(response => {	
    	if(response.data.status == 1)
    	{
    		store.dispatch(getUserSuccess(response.data.data));
    	}
    	//console.log(response.data);
      
      return response;
    });
}


/** WEBPACK FOOTER **
 ** ./src/client/app/api/user-api.js
 **/